import { frontendURL } from '../../../helper/URLHelper';
import SalesDashboard from './pages/SalesDashboard.vue';

const commonMeta = {
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/sales'),
    name: 'sales_dashboard',
    component: SalesDashboard,
    meta: commonMeta,
  },
];
